import { render, staticRenderFns } from "./TabConfig.vue?vue&type=template&id=542b6fce&"
import script from "./TabConfig.vue?vue&type=script&lang=js&"
export * from "./TabConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports